import { styled, t, useTheme } from "@superset-ui/core";
import React, { useEffect } from "react";
import { Button } from "antd";

/**
 * @property {boolean} popupVisible 팝업 노출 여부
 * @property {string[]} categoryList 카테고리 리스트
 * @property {} handleApply 적용 버튼 클릭 시 이벤트
 * @property {} handleCancel 취소 버튼 클릭 시 이벤트
 */
interface PopoverContentProps {
    popupVisible: boolean;
    categoryList: string[];
    handleApply: (currentList: string[]) => void;
    handleCancel: () => void;
}

const PopoverContent = (props: PopoverContentProps) => {
    // PopoverContent의 props
    const { categoryList, popupVisible, handleApply, handleCancel } = props;

    // superset-ui의 theme
    const { gridUnit, colors } = useTheme();

    // 선택된 카테고리
    const [selectedCategory, setSelectedCategory] = React.useState<string | undefined>(undefined);

    // 현재 카테고리 순서
    const [currentList, setCurrentList] = React.useState<string[] | undefined>(undefined);

    /**
     * @function hancleClickList
     * @description 카테고리 클릭 시 선택된 카테고리 변경
     * @param {string} category 선택한 카테고리
     */
    const hancleClickList = (category: string) => {
        setSelectedCategory(category);
    };

    /**
     * @function handleCaretUp
     * @description 카테고리 순서 변경 (위로 이동)
     */
    const handleCaretUp = () => {
        const filteredList = currentList?.filter((item) => item !== selectedCategory);
        const selectedIndex = currentList?.findIndex((item) => item === selectedCategory);
        if (filteredList && typeof selectedIndex === "number" && selectedCategory) {
            if (selectedIndex === 0) return;
            filteredList.splice(selectedIndex - 1, 0, selectedCategory);
            setCurrentList(filteredList);
        }
    };

    /**
     * @function handleCaretDown
     * @description 카테고리 순서 변경 (아래로 이동)
     */
    const handleCaretDown = () => {
        const filteredList = currentList?.filter((item) => item !== selectedCategory);
        const selectedIndex = currentList?.findIndex((item) => item === selectedCategory);

        if (filteredList && typeof selectedIndex === "number" && selectedCategory) {
            if (selectedIndex === filteredList.length) return;
            filteredList.splice(selectedIndex + 1, 0, selectedCategory);
            setCurrentList(filteredList);
        }
    };

    /**
     * @function handleClickApply
     * @description 적용 버튼 클릭 시 이벤트
     */
    const handleClickApply = () => {
        if (currentList) {
            handleApply(currentList);
        }
    };

    /**
     * @function handleClickCancel
     * @description 취소 버튼 클릭 시 이벤트
     */
    const handleClickCancel = () => {
        setCurrentList(categoryList);
        handleCancel();
    };

    /**
     * @private useEffect
     * @description popupVisible이 변경되면 현재 카테고리 순서를 categoryList로 초기화
     */
    useEffect(() => {
        if (popupVisible) {
            setCurrentList(categoryList);
            setSelectedCategory(categoryList[0]);
        }
    }, [popupVisible, categoryList]);

    return (
        <Wrap>
            {/* <ContentHeader>{t("Rearrange Category Order")}</ContentHeader> */}
            <ContentBody>
                <CategoryContainer>
                    {currentList?.map((category, idx) => (
                        <CategoryList
                            active={category === selectedCategory}
                            activeBg={colors.primary.light4}
                            hoverBg={colors.grayscale.light4}
                            key={`${category}_${idx}`}
                            onClick={() => hancleClickList(category)}
                        >
                            {category}
                        </CategoryList>
                    ))}
                </CategoryContainer>
                <ButtonContainer>
                    <CustomButton onClick={handleCaretUp}>
                        <IconButton className="fa fa-caret-up" gridUnit={gridUnit} />
                    </CustomButton>
                    <CustomButton onClick={handleCaretDown}>
                        <IconButton className="fa fa-caret-down" gridUnit={gridUnit} />
                    </CustomButton>
                </ButtonContainer>
            </ContentBody>
            <ContentFooter>
                <Button onClick={handleClickApply}>{t("Apply")}</Button>
                <Button onClick={handleClickCancel}>{t("Cancel")}</Button>
            </ContentFooter>
        </Wrap>
    );
};

const Wrap = styled.div`
    width: 300px;
`;

const ContentBody = styled.div`
    display: flex;
`;

const ContentFooter = styled.div`
    padding: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const CategoryContainer = styled.div`
    flex-basis: 80%;
    height: 300px;
    overflow-y: scroll;
`;

const ButtonContainer = styled.div`
    flex-basis: 20%;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

type CategoryListProps = {
    active: boolean;
    hoverBg: string;
    activeBg: string;
};

const CategoryList = styled.div<CategoryListProps>`
    height: 32px;
    line-height: 32px;
    padding: 0 8px;
    background-color: ${(props) => (props.active ? props.activeBg : "transparent")};
    &:hover {
        background-color: ${(props) => props.hoverBg};
    }
`;

const CustomButton = styled(Button)`
    width: 32px;
    height: 32px;
    padding: 0;
    line-height: 32px;
`;

const IconButton = styled.i<{ gridUnit: number }>`
    /* position: absolute;
    right: ${(props) => 3 * props.gridUnit};
    top: ${(props) => 3 * props.gridUnit}; */
`;
export default PopoverContent;
